<template>
  <tk-flex
    middle
    column
    center
    class="bg-white"
  >
    <tk-image class="error_image" :width="160" :height="160" :src="require('@/assets/image/error.png')">
    </tk-image>
    <div class="error_title">{{ lang.product.produc_detail_emptyTitle }}</div>
    <div class="error_sub_title">{{ lang.product.produc_detail_emptySubTitle }}</div>
  </tk-flex>
</template>

<script>
import en from '../en'
import cn from '../cn'
export default {
  props: {
    langType: {
      type: String,
      default: 'en'
    }
  },
  data () {
    return {
      lang: en
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.langType === 'en' ? this.lang = en : this.lang = cn
    }
  }
}
</script>

<style lang="scss" scoped>
.error_image {
  margin-top: 150px;
}
.error_title {
  margin-top: 23px;
  font-family: BeVie-Bold;
  font-weight: 700;
  font-size: 15px;
}
.error_sub_title {
  margin-top: 5px;
  color: #84888F;
  font-family: BeVie-Light;
  font-weight: 300;
  font-size: 13px;
}
</style>
